import { Text, Tag, TagLeftIcon, TagRightIcon } from '@chakra-ui/react';
import { FilterLines } from '@kula-ai/icons/outline/FilterLines';
import { ChevronDown } from '@kula-ai/icons/outline/ChevronDown';
import { useKFlags } from '@/hooks/use-k-flags';
import { getFilterTriggerStyles } from '@/components/filters_revamp/utils/filterTriggerStyles';

interface FilterTriggerProps {
  onClick?: () => void;
  triggerText?: string;
  isApplied?: boolean;
}

export const FilterTrigger = ({
  onClick,
  triggerText = 'Filters',
  isApplied = false,
}: FilterTriggerProps) => {
  const { feReportsV3 } = useKFlags();

  // Neutral (quaternary) until a filter is applied, then highlighted
  // (tertiary). Only the v3 chip trigger adopts the variant; the legacy
  // inline-link trigger keeps its existing look.
  const triggerStyles = getFilterTriggerStyles(isApplied);

  const tagProps = feReportsV3
    ? {
        height: '32px',
        p: '8px',
        background: triggerStyles.bg,
        border: triggerStyles.border,
        borderColor: triggerStyles.borderColor,
      }
    : { height: '36px', p: '0', background: 'inherit' };

  const contentColor = feReportsV3 ? triggerStyles.contentColor : 'primary-600';

  return (
    <Text as="a">
      <Tag
        cursor="pointer"
        onClick={onClick}
        as="a"
        {...tagProps}
        data-test-id="filter-trigger"
      >
        <TagLeftIcon
          as={FilterLines}
          color={contentColor}
          width="16px"
          height="16px"
        />
        <Text size="sm-medium" color={contentColor}>
          {triggerText}
        </Text>
        <TagRightIcon as={ChevronDown} color={contentColor} />
      </Tag>
    </Text>
  );
};
